import React, { useState } from 'react';
import {
  Box,
  Button,
  FlexBox,
  ModalDialog,
  ModalDialogBody,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogHeader,
  ModalDialogNav,
} from '@vp/swan';
import './debugTool.css';
import { useDebugContext } from 'src/hooks/DebugContextHooks';
import { DebugToolbarToggle } from './DebugToolbarToggle';
import { StatsigFeatureGatesContents } from './feature-gate/StatsigFeatureGatesContents';

const DebugTool: React.FC = () => {
  const { debugMode: isDebugMode } = useDebugContext();
  const [isOpen, setIsOpen] = useState(false);

  const openDebugModal = () => {
    setIsOpen(true);
  };

  return (
    isDebugMode && (
      <>
        <Box darkMode className="debug-tool" px={4}>
          <FlexBox justifyContent={'space-between'} alignItems={'center'}>
            Debug Tool
            <Button onClick={openDebugModal}>Feature Gates</Button>
            <DebugToolbarToggle />
          </FlexBox>
        </Box>
        <ModalDialog
          onRequestDismiss={() => {
            setIsOpen(false);
          }}
          isOpen={isOpen}
        >
          <ModalDialogContent>
            <ModalDialogNav>
              <ModalDialogCloseButton accessibleText="Close" />
            </ModalDialogNav>
            <ModalDialogHeader>Feature Gates</ModalDialogHeader>
            <ModalDialogBody>
              <StatsigFeatureGatesContents />
            </ModalDialogBody>
          </ModalDialogContent>
        </ModalDialog>
      </>
    )
  );
};

export default DebugTool;
